import React from 'react';
import { Flame } from 'lucide-react';
export function UrgencyBanner() {
  return <div className="bg-gradient-to-r from-[#b91c1c] via-[#dc2626] to-[#b91c1c] py-5 px-4" data-id="element-215">
      <div className="max-w-lg mx-auto text-center" data-id="element-216">
        {/* Title */}
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-217">
          <Flame className="text-yellow-300" size={18} data-id="element-218" />
          <span className="text-white font-extrabold text-sm md:text-base tracking-wide uppercase" data-id="element-219">
            Promoción por tiempo limitado
          </span>
        </div>

        {/* Progress bar */}
        <div className="flex items-center gap-3 mb-3" data-id="element-220">
          <div className="flex items-center gap-1.5 shrink-0" data-id="element-221">
            <span className="text-yellow-200 text-xs" data-id="element-222">⚠️</span>
            <span className="text-white/90 text-[11px] md:text-xs font-medium" data-id="element-223">
              Cupos disponibles agotándose
            </span>
          </div>
          <div className="flex-1 relative" data-id="element-224">
            <div className="w-full h-3 bg-black/20 rounded-full overflow-hidden" data-id="element-225">
              <div className="h-full rounded-full bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500" style={{
              width: '80%'
            }} data-id="element-226"></div>
            </div>
          </div>
          <span className="bg-green-500 text-white text-[10px] md:text-[11px] font-bold px-2 py-0.5 rounded-full shrink-0" data-id="element-227">
            80% tomados
          </span>
        </div>

        {/* Subtitle */}
        <p className="text-white/80 text-[11px] md:text-xs leading-snug" data-id="element-228">
          Últimos cupos a precio promocional — una vez agotados, vuelve al
          precio original.
        </p>
      </div>
    </div>;
}